import { render, staticRenderFns } from "./landingFeatures.vue?vue&type=template&id=9048f9a8&"
import script from "./landingFeatures.vue?vue&type=script&lang=js&"
export * from "./landingFeatures.vue?vue&type=script&lang=js&"
import style0 from "./landingFeatures.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports